import React from 'react';
import './index.less';
import { Table } from '@beehive/components';
import DotDotDot from '@mpc/common/src/components/DotDotDot';

const AuditProgress = () => {
  const prefixClx = 'bidding-detail-audit-progress';

  return (
    <div className={prefixClx}>
      <Table
        columns={[
          {
            title: '节点',
            dataIndex: 'name',
            key: 'name',
            width: 100,
          },
          {
            title: '操作',
            dataIndex: 'age',
            key: 'age',
            width: 100,
          },
          {
            title: '操作时间',
            dataIndex: 'address',
            key: 'address',
            width: 200,
          },
          {
            title: '操作人',
            dataIndex: 'a',
            key: 'a',
          },
          {
            title: '接收人',
            dataIndex: 'b',
            key: 'b',
          },
          {
            title: '意见',
            dataIndex: 'c',
            key: 'c',
            render: (v: any) => <DotDotDot clamp={1}>{v}</DotDotDot>,
          },
        ]}
        data={[
          {
            id: 1,
            name: 'aaa',
            age: 'aaa',
            address: 'aaa',
            a: 'aaa',
            b: 'aaa',
            c: `Lorem ipsum, dolor sit amet consectetur adipisicing elit.
          Suscipit nam reiciendis ea ad veniam quia laudantium cumque
          harum error blanditiis, nihil corporis reprehenderit possimus
          aliquam repudiandae sint repellendus debitis sed!`,
          },
        ]}
        size="default"
        border
        noEvenColor
      />
    </div>
  );
};

export default AuditProgress;
